var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ejs-dialog',{ref:"commonDialog",attrs:{"buttons":_vm.btnMessage,"header":_vm.headerMessage,"animationSettings":_vm.animationSettings,"content":_vm.infoMessage,"showCloseIcon":_vm.closeIcon,"closeOnEscape":"false","isModal":"false","visible":false,"cssClass":"h-layer","zIndex":"1200","height":"250px","width":"350"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }